<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Requests over time</span>
      <span class="api-card__desc">Daily API requests for the selected period.</span>
    </div>
    <span class="granularity-chip">Daily</span>
  </div>

  <div class="usage-chart-body">
    <app-line-chart [points]="points" [dateLabels]="true" valueLabel="requests"></app-line-chart>
  </div>
</div>
